export const selectLogTable = (state) => state.logTable;
